import _classCallCheck from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { RestingDefault } from "../utils/helpers";
import { calcArms } from "./calcArms";
import { calcHips } from "./calcHips";
import { calcLegs } from "./calcLegs";
/** Class representing pose solver. */

export var PoseSolver = /*#__PURE__*/function () {
  function PoseSolver() {
    _classCallCheck(this, PoseSolver);
  }

  _createClass(PoseSolver, null, [{
    key: "solve",

    /**
     * Combines arm, hips, and leg calcs into one method
     * @param {Array} lm3d : array of 3D pose vectors from tfjs or mediapipe
     * @param {Array} lm2d : array of 2D pose vectors from tfjs or mediapipe
     * @param {String} runtime: set as either "tfjs" or "mediapipe"
     * @param {IPoseSolveOptions} options: options object
     */
    value: function solve(lm3d, lm2d) {
      var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref$runtime = _ref.runtime,
          runtime = _ref$runtime === void 0 ? "mediapipe" : _ref$runtime,
          _ref$video = _ref.video,
          video = _ref$video === void 0 ? null : _ref$video,
          _ref$imageSize = _ref.imageSize,
          imageSize = _ref$imageSize === void 0 ? null : _ref$imageSize,
          _ref$enableLegs = _ref.enableLegs,
          enableLegs = _ref$enableLegs === void 0 ? true : _ref$enableLegs;

      var _a, _b, _c, _d;

      if (!lm3d && !lm2d) {
        console.error("Need both World Pose and Pose Landmarks");
        return;
      } // format and normalize values given by tfjs output


      if (video) {
        var videoEl = typeof video === "string" ? document.querySelector(video) : video;
        imageSize = {
          width: videoEl.videoWidth,
          height: videoEl.videoHeight
        };
      }

      if (runtime === "tfjs" && imageSize) {
        var _iterator = _createForOfIteratorHelper(lm3d),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var e = _step.value;
            e.visibility = e.score;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        var _iterator2 = _createForOfIteratorHelper(lm2d),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _e = _step2.value;
            _e.x /= imageSize.width;
            _e.y /= imageSize.height;
            _e.z = 0;
            _e.visibility = _e.score;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      var Arms = calcArms(lm3d);
      var Hips = calcHips(lm3d, lm2d);
      var Legs = enableLegs ? calcLegs(lm3d) : null; //DETECT OFFSCREEN AND RESET VALUES TO DEFAULTS

      var rightHandOffscreen = lm3d[15].y > 0.1 || ((_a = lm3d[15].visibility) !== null && _a !== void 0 ? _a : 0) < 0.23 || 0.995 < lm2d[15].y;
      var leftHandOffscreen = lm3d[16].y > 0.1 || ((_b = lm3d[16].visibility) !== null && _b !== void 0 ? _b : 0) < 0.23 || 0.995 < lm2d[16].y;
      var leftFootOffscreen = lm3d[23].y > 0.1 || ((_c = lm3d[23].visibility) !== null && _c !== void 0 ? _c : 0) < 0.63 || Hips.Hips.position.z > -0.4;
      var rightFootOffscreen = lm3d[24].y > 0.1 || ((_d = lm3d[24].visibility) !== null && _d !== void 0 ? _d : 0) < 0.63 || Hips.Hips.position.z > -0.4;
      Arms.UpperArm.l = Arms.UpperArm.l.multiply(leftHandOffscreen ? 0 : 1);
      Arms.UpperArm.l.z = leftHandOffscreen ? RestingDefault.Pose.LeftUpperArm.z : Arms.UpperArm.l.z;
      Arms.UpperArm.r = Arms.UpperArm.r.multiply(rightHandOffscreen ? 0 : 1);
      Arms.UpperArm.r.z = rightHandOffscreen ? RestingDefault.Pose.RightUpperArm.z : Arms.UpperArm.r.z;
      Arms.LowerArm.l = Arms.LowerArm.l.multiply(leftHandOffscreen ? 0 : 1);
      Arms.LowerArm.r = Arms.LowerArm.r.multiply(rightHandOffscreen ? 0 : 1);
      Arms.Hand.l = Arms.Hand.l.multiply(leftHandOffscreen ? 0 : 1);
      Arms.Hand.r = Arms.Hand.r.multiply(rightHandOffscreen ? 0 : 1); //skip calculations if disable legs

      if (Legs) {
        Legs.UpperLeg.l = Legs.UpperLeg.l.multiply(rightFootOffscreen ? 0 : 1);
        Legs.UpperLeg.r = Legs.UpperLeg.r.multiply(leftFootOffscreen ? 0 : 1);
        Legs.LowerLeg.l = Legs.LowerLeg.l.multiply(rightFootOffscreen ? 0 : 1);
        Legs.LowerLeg.r = Legs.LowerLeg.r.multiply(leftFootOffscreen ? 0 : 1);
      }

      return {
        RightUpperArm: Arms.UpperArm.r,
        RightLowerArm: Arms.LowerArm.r,
        LeftUpperArm: Arms.UpperArm.l,
        LeftLowerArm: Arms.LowerArm.l,
        RightHand: Arms.Hand.r,
        LeftHand: Arms.Hand.l,
        RightUpperLeg: Legs ? Legs.UpperLeg.r : RestingDefault.Pose.RightUpperLeg,
        RightLowerLeg: Legs ? Legs.LowerLeg.r : RestingDefault.Pose.RightLowerLeg,
        LeftUpperLeg: Legs ? Legs.UpperLeg.l : RestingDefault.Pose.LeftUpperLeg,
        LeftLowerLeg: Legs ? Legs.LowerLeg.l : RestingDefault.Pose.LeftLowerLeg,
        Hips: Hips.Hips,
        Spine: Hips.Spine
      };
    }
  }]);

  return PoseSolver;
}();
/** expose arm rotation calculator as a static method */

PoseSolver.calcArms = calcArms;
/** expose hips position and rotation calculator as a static method */

PoseSolver.calcHips = calcHips;
/** expose leg rotation calculator as a static method */

PoseSolver.calcLegs = calcLegs;